// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__llusv","skeleton_animate":"title_skeleton_animate__v8gZI","loading-roller":"title_loading-roller__DP2Kl"};